<template>
    <v-form v-model="valid" ref="despublicarPropiedad" lazy-validation>
        <v-row>
            <v-col cols="12">
                <v-item-group v-model="despublicar.razon"
                              mandatory>
                  <v-row>
                    <v-col cols="12">
                      <v-alert type="info" outlined :value="true" style="border-radius: 5px">
                        Al despublicar una propiedad, automaticamente se deshabilitará de los listados web
                      </v-alert>
                    </v-col>

                    <v-col v-for="item in constants.unpublishStatus"
                           :key="item.label"
                           cols="12"
                           md="4">
                      <v-item>
                        <v-card slot-scope="{ active, toggle }"
                                :color="active ? 'abadPrimary darken-2' : 'grey'"
                                class="d-flex align-center"
                                dark
                                height="100"
                                @click="toggle">
                          <v-scroll-y-transition>
                            <div class="flex text-h6 text-center">
                              <v-icon class="mb-2">{{item.icon}}</v-icon>
                              <br>
                              {{item.label}}
                            </div>
                          </v-scroll-y-transition>
                        </v-card>
                      </v-item>
                    </v-col>

                    <v-col cols="12" v-if="despublicar.razon !== 2">
                      <v-autocomplete v-model="despublicar.vendidoOArrendadoPor"
                                      :label="despublicar.razon === 0 ? 'Vendido por' : 'Arrendado por'"
                                      prepend-icon="person"
                                      :items="advisers"
                                      item-text="nombres">
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" v-if="despublicar.razon !== 2">
                      <v-text-field v-model="despublicar.fecha"
                                    mask="####-##-##"
                                    prepend-icon="event"
                                    :label="despublicar.razon === 0 ? 'Fecha de venta' : 'Fecha de arriendo'"
                                    placeholder="AAAA-MM-DD">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" v-if="despublicar.razon !== 2">
                      <v-text-field v-money="money"
                                    v-model.lazy="despublicar.valor"
                                    :label="despublicar.razon === 0 ? 'Valor de venta' : 'Valor de arriendo'"
                                    prepend-icon="attach_money">
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn @click="submit()"
                             block
                             dark
                             large
                             color="abadPrimary">
                        Actualizar propiedad
                        <v-icon right>send</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-item-group>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import constants from '@/pages/RealEstate/libs/constants.js'
import rules from '@/libs/rules'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      advisers: state => state.realEstate.advisers,
      despublicar: state => state.realEstate.despublicar
    }),
    razon () {
      switch (this.despublicar.razon) {
        case 0:
          return 'vendido'
        case 1:
          return 'arrendado'
        case 2:
          return 'retirado'
        default:
          return ''
      }
    }
  },
  data () {
    return {
      constants,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      rules,
      valid: true
    }
  },
  methods: {
    submit () {
      const request = {
        razon: this.razon,
        vendidoOArrendadoPor: this.despublicar.vendidoOArrendadoPor,
        fecha: this.despublicar.fecha,
        valor: this.despublicar.valor.replace(/\./g, '')
      }

      console.log(request)
    }
  }
}
</script>
